import {observer} from "mobx-react";
import React from "react";

const ProfileButtonUI = observer((props) => {
    return <button className={props.disabled? "buttons": `buttons ${props.color}`} style={props.disabled? {width: '100%', margin: 0, background: "#E6E9ED"} : {width: '100%', margin: 0}} type="button" onClick={props.func} disabled={props.disabled}>{props.text}</button>})

export default ProfileButtonUI;